export const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || "/api";

function clearAuthAndRedirectToLogin() {
  try {
    localStorage.removeItem("authToken");
    localStorage.removeItem("authUser");
  } catch {
    /* ignore */
  }
  if (typeof window !== "undefined" && window.location.pathname !== "/login") {
    window.location.assign("/login");
  }
}

export async function apiFetch<T = unknown>(
  path: string,
  options: RequestInit & { token?: string | null } = {},
): Promise<T> {
  const { token: tokenOption, ...restOptions } = options;
  const token = Object.prototype.hasOwnProperty.call(options, "token")
    ? tokenOption
    : localStorage.getItem("authToken");

  const headers: Record<string, string> = {
    ...(restOptions.headers as Record<string, string> | undefined),
  };

  if (token) headers.Authorization = `Bearer ${token}`;

  const isFormData =
    typeof FormData !== "undefined" && restOptions.body instanceof FormData;
  if (isFormData && headers["Content-Type"]) {
    delete headers["Content-Type"];
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...restOptions,
    headers,
  });

  const text = await response.text();
  let data: T | { error?: string } | null = null;
  if (text) {
    try {
      data = JSON.parse(text) as T;
    } catch {
      /* non-JSON */
    }
  }

  if (!response.ok) {
    if (response.status === 401 && token) {
      clearAuthAndRedirectToLogin();
    }
    const message =
      (data && typeof data === "object" && "error" in data && data.error) ||
      `Request failed (${response.status})`;
    throw new Error(String(message));
  }

  return data as T;
}
